import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { getCheckoutHref, handleCheckoutClick } from '../utils/checkout';
import { primaryButtonClass, type ButtonSize, type ButtonTone } from '../utils/buttonStyles';
interface CheckoutButtonProps {
  label: string;
  id?: string;
  size?: ButtonSize;
  tone?: ButtonTone;
  className?: string;
  tabIndex?: number;
}

/** Every purchase CTA goes through here so they share one destination (data/checkout.ts). */
export function CheckoutButton({
  label,
  id,
  size = 'md',
  tone = 'coral',
  className = '',
  tabIndex
}: CheckoutButtonProps) {
  return <a id={id} href={getCheckoutHref()} onClick={handleCheckoutClick} tabIndex={tabIndex} className={`${primaryButtonClass(size, tone)} ${className}`} data-id="element-50" data-mp="18nb186vj32t6">
      <span data-id="element-51" data-mp="331lklztct4rk">{label}</span>
      <ArrowRightIcon className="hidden h-[18px] w-[18px] shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 sm:block" strokeWidth={2.5} aria-hidden data-id="element-52" data-mp="331vgg412y656" />
    </a>;
}